import React from 'react';
import { Controller } from 'react-hook-form';

import { BirthdayPicker as GarnishBirthdayPicker } from '../BirthdayPicker';
import type { ControlledProps, FormProps } from './types';

type ComponentProps = React.ComponentProps<typeof GarnishBirthdayPicker>;
type OmittedProps = ControlledProps;
type Props = FormProps & Omit<ComponentProps, OmittedProps>;

export const BirthdayPicker = ({ name, control, rules, ...rest }: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, onBlur, value } }) => (
        <GarnishBirthdayPicker
          value={value}
          onChange={(selected) => {
            onChange(selected);
            onBlur();
          }}
          {...rest}
        />
      )}
    />
  );
};
